import es from "./es.json";

const messages = { es };
const defaultLocale = "es";

/**
 * Get a namespaced message (e.g. "progress.global") and optionally interpolate placeholders.
 * @param {string} key - Dot-separated key (e.g. "progress.global", "blocks.completedCount")
 * @param {Record<string, string|number>} [vars] - Replace {key} in the message with vars[key]
 * @param {string} [locale] - Locale code (default: es)
 * @returns {string}
 */
export function getMessage(key, vars = {}, locale = defaultLocale) {
  if (typeof key !== "string") return "";
  const dict = messages[locale] || messages.es;
  const value = key.split(".").reduce((obj, k) => (obj && obj[k]) ?? null, dict);
  const str = typeof value === "string" ? value : key;
  if (Object.keys(vars).length === 0) return str;
  return Object.entries(vars).reduce(
    (acc, [k, v]) => acc.replace(new RegExp(`\\{${k}\\}`, "g"), String(v)),
    str
  );
}

export { messages, defaultLocale };
